import { render, staticRenderFns } from "./TelegramDetail.vue?vue&type=template&id=8df6b476&scoped=true&"
import script from "./TelegramDetail.vue?vue&type=script&lang=js&"
export * from "./TelegramDetail.vue?vue&type=script&lang=js&"
import style0 from "./TelegramDetail.vue?vue&type=style&index=0&id=8df6b476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df6b476",
  null
  
)

export default component.exports